/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import createValidateMethod from '@tcp/core/src/utils/formValidation/createValidateMethod';
import getStandardConfig from '@tcp/core/src/utils/formValidation/validatorStandardConfig';
import PasswordField from '@tcp/core/src/components/features/account/common/molecule/PasswordField/views/PasswordField.view';
import Recaptcha from '@tcp/core/src/components/common/molecules/recaptcha/recaptcha';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import SpinnerOverlay from '@tcp/core/src/components/common/atoms/SpinnerOverlay';
import emailSignupAbstractor from '@tcp/core/src/services/abstractors/common/EmailSmsSignup';
import { Field, reduxForm } from 'redux-form';
import { routerPush } from '@tcp/core/src/utils';
import InputCheckbox from '@tcp/core/src/components/common/atoms/InputCheckbox';
import TextBox from '@tcp/core/src/components/common/atoms/TextBox';
import Button from '@tcp/core/src/components/common/atoms/Button';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import RichText from '@tcp/core/src/components/common/atoms/RichText';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import { getContinueAsGuestPayload } from '@tcp/core/src/constants/analytics';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
} from '@tcp/core/src/utils/labels/labelUtilty';
import styles, {
  ForgotPasswordBlock,
  RememberForgotPassBlock,
} from '../styles/LoginSelectionFormV2.styles';
import Anchor from '../../../../../../common/atoms/Anchor';
import useLoginSectionForm from '../../../common/LoginSelection/useLoginSectionForm';
import LoginOptionView from '../../LoginOptions/views/LoginOptions.view';
import LineSeperator from '../../../atoms/LineSeperator';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
  lblInvalidVerifiedEmail,
} from '../../../../../../../utils/labels/globalLogin.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblPassword,
} from '../../../../../../../utils/labels/globalGeneric.labels';
import {
  GLOBAL_ACCESSIBILITY_LABELS,
  GlobalAccessibilityLabels,
  lblPasswordTooltip,
} from '../../../../../../../utils/labels/globalAccessibility.labels';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblLogin,
} from '../../../../../../../utils/labels/globalActions.labels';

const OR = 'or';
const orRenderer = (isV2Flow, fromPlccICLogin) => {
  return (
    <BodyCopy
      className={`elem-mb-MED ${fromPlccICLogin && `elem-mt-MED`} ${isV2Flow ? 'elem-mt-MED' : ''}`}
      component="p"
      textAlign="center"
      fontSize="fs14"
      fontWeight="semibold"
      fontFamily="secondary"
    >
      {OR}
    </BodyCopy>
  );
};

const handleBriteVerify = (
  userSavedEmail,
  setShowBriteErrorMessage,
  setBriteErrorMessageData,
  handleContinueAsGuest
) => {
  setShowBriteErrorMessage(false);
  return emailSignupAbstractor
    .verifyEmail(userSavedEmail)
    .then((status) => {
      if (status && status.error) {
        return Promise.reject();
      }
      handleContinueAsGuest();
      return Promise.resolve();
    })
    .catch(() => {
      setShowBriteErrorMessage(true);
      setBriteErrorMessageData(
        getLabelFromCopyOrFromTranslation(
          `${GLOBAL_LOGIN_LABELS}.${lblInvalidVerifiedEmail}`,
          GlobalLoginLabels
        )
      );
    });
};

const getContinueAsGuestBtn = (
  isV2Flow,
  variation,
  handleContinueAsGuest,
  isRememberedUser,
  lblLoginCheckoutAsGuest,
  userSavedEmail,
  setShowBriteErrorMessage,
  setBriteErrorMessageData,
  isBriteVerifyForLoginEnabled
) => {
  return (
    <>
      {(isV2Flow || variation === 'checkout') && (
        <div className="elem-mb-LRG">
          {!isRememberedUser && (
            <ClickTracker clickData={getContinueAsGuestPayload('checkout-popup')}>
              <Button
                fill="WHITE"
                type="button"
                buttonVariation="fixed-width"
                dataLocator="login-logincta"
                fullWidth
                onClick={() =>
                  isBriteVerifyForLoginEnabled && userSavedEmail
                    ? handleBriteVerify(
                        userSavedEmail,
                        setShowBriteErrorMessage,
                        setBriteErrorMessageData,
                        handleContinueAsGuest
                      )
                    : handleContinueAsGuest()
                }
                className="rounded-corner test-guest-button"
                spc
              >
                {lblLoginCheckoutAsGuest}
              </Button>
            </ClickTracker>
          )}
        </div>
      )}
    </>
  );
};
const rememberForgotPassBlock = (
  userplccCardNumber,
  userplccCardId,
  variation,
  setRememberUser,
  showForgotPassword,
  lblLoginSaveMyPlace,
  lblLoginRememberMe,
  lblLoginRememberMeTxt,
  lblLoginForgotPwdCta
) => (
  <RememberForgotPassBlock>
    <div>
      {userplccCardNumber && userplccCardId && (
        <BodyCopy component="div" className="remember-check">
          <Field
            name="plcc_checkbox"
            component={InputCheckbox}
            dataLocator="login-savemyplcccardcb"
          >
            <BodyCopy fontFamily="secondary" tag="span" fontSize="fs10">
              {lblLoginSaveMyPlace?.replace('#number', `${userplccCardNumber}`)}
            </BodyCopy>
          </Field>
        </BodyCopy>
      )}
      <BodyCopy component="div" className="remember-check">
        <Field
          name="rememberMe"
          component={InputCheckbox}
          dataLocator="login-remembermecb"
          className={`remember-me-check ${variation === 'checkout' && 'remember-me-checkbox1'}`}
          onChange={setRememberUser}
        >
          <BodyCopy fontFamily="secondary" tag="span" fontWeight="semibold" fontSize="fs12">
            {lblLoginRememberMe}
          </BodyCopy>
          <BodyCopy fontFamily="secondary" tag="span" fontSize="fs10">
            {lblLoginRememberMeTxt}
          </BodyCopy>
        </Field>
      </BodyCopy>
    </div>

    <ForgotPasswordBlock className="forget-password-wrapper">
      <Anchor
        underline
        anchorVariation="primary"
        dataLocator="login-forgotpasswordlnk"
        onClick={showForgotPassword}
        id="forgotPasswordForm"
        className="forgot-password"
      >
        {lblLoginForgotPwdCta}
      </Anchor>
    </ForgotPasswordBlock>
  </RememberForgotPassBlock>
);

const LoginSelectionFormV2 = (props) => {
  const {
    tooltipContent,
    change,
    showRecaptcha,
    maskedPhoneNumber,
    isV2Flow,
    handleContinueAsGuest,
    loginErrorMessage,
    userplccCardNumber,
    userplccCardId,
    className,
    variation,
    isLoading,
    isLoginWithEmailOTPEnabled,
    setRememberUser,
    isRememberedUser,
    isLoginModal,
    rememberedEmail,
    isCanada,
    fromPlccICLogin,
    isPlccLoginLoading,
    phoneCountryCode,
    phoneCountryCodeSS,
    userSavedEmail,
    setShowBriteErrorMessage,
    setBriteErrorMessageData,
    isBriteVerifyForLoginEnabled,
  } = props;
  const [loginClicked, setLoginClicked] = useState(false);

  useEffect(() => {
    if (isLoading === false) {
      setLoginClicked(false);
      change('recaptchaToken', '');
    }
  }, [isLoading]);

  const {
    lbl_login_forgetPasswordCTA: lblLoginForgotPwdCta,
    lbl_login_saveMyPlace: lblLoginSaveMyPlace,
    lbl_login_rememberMe: lblLoginRememberMe,
    lbl_login_rememberMeHelpText: lblLoginRememberMeTxt,
    lbl_login_loginAndCheckout: lblLoginAndCheckout,
    lbl_login_checkout_as_guest: lblLoginCheckoutAsGuest,
  } = getLabelFromCopyOrFromTranslation(GLOBAL_LOGIN_LABELS, GlobalLoginLabels);

  const {
    submitForm2,
    emailAddress,
    showForgotPassword,
    isSMSOpted,
    sendCodeViaEmail,
    isLoginBtnDisbaled,
  } = useLoginSectionForm(props, routerPush);

  const handleSubmitOtp = (e) => {
    setShowBriteErrorMessage(false);
    setBriteErrorMessageData(false);
    sendCodeViaEmail(e);
  };

  const handleSubmitForm = (e) => {
    setShowBriteErrorMessage(false);
    setBriteErrorMessageData(false);
    submitForm2(e, 'sms');
  };
  const countryDialCode = phoneCountryCode || phoneCountryCodeSS;
  const showSMSOption = countryDialCode ? countryDialCode === '+1' : true;
  return (
    <>
      {isLoading && !loginClicked && (
        <SpinnerOverlay
          isLoginModal={isLoginModal}
          isNewLoginScreen={true}
          fromPlccICLogin={fromPlccICLogin}
        />
      )}
      <div className={`${className} ${!fromPlccICLogin && `elem-mb-LRG`}`}>
        <form name="LoginForm" onSubmit={submitForm2} className={'login-form-container'} noValidate>
          <React.Fragment>
            {loginErrorMessage && (
              <BodyCopy
                fontSize="fs12"
                fontWeight="semibold"
                color="red.500"
                className={`${!fromPlccICLogin && 'elem-ml-XL'} elem-mb-MED`}
              >
                <RichText className="richTextColor" richTextHtml={loginErrorMessage} />
              </BodyCopy>
            )}
            <BodyCopy component="div" className="password-container">
              {/* For browser password manager */}
              <input
                type="text"
                id="hidden_emailAddress"
                aria-hidden="true"
                name="hidden_emailAddress"
                value={emailAddress}
                className="hidden-field"
              />
              <Field
                id="password"
                placeholder={getLabelFromCopyOrFromTranslation(
                  `${GLOBAL_GENERIC_LABELS}.${lblPassword}`,
                  GlobalGenericLabels
                )}
                name="password"
                component={PasswordField}
                dataLocator="login-passwordfield"
                errorDataLocator="login-passworderror"
                showSuccessCheck={false}
                enableSuccessCheck={false}
                className={`${!fromPlccICLogin && 'elem-mt-SM'} elem-ml-SM fs14 loginShowTop`}
                tooltipContent={tooltipContent}
                tooltipAriaLabel={getLabelFromCopyOrFromTranslation(
                  `${GLOBAL_ACCESSIBILITY_LABELS}.${lblPasswordTooltip}`,
                  GlobalAccessibilityLabels
                )}
                spc
                newLoginScreen
              />
            </BodyCopy>
            {/* remember me */}
            {rememberForgotPassBlock(
              userplccCardNumber,
              userplccCardId,
              variation,
              setRememberUser,
              showForgotPassword,
              lblLoginSaveMyPlace,
              lblLoginRememberMe,
              lblLoginRememberMeTxt,
              lblLoginForgotPwdCta
            )}
            {/* REcapthha */}
            {showRecaptcha && (
              <BodyCopy component="div" className="recaptcha_loginotp elem-mt-MED">
                <Recaptcha
                  verifyCallback={(token) => change('recaptchaToken', token)}
                  expiredCallback={() => change('recaptchaToken', '')}
                />
                <Field
                  id="recaptchaToken"
                  component={TextBox}
                  type="hidden"
                  name="recaptchaToken"
                  data-locator="merge-account-confirmation-recaptchca"
                />
              </BodyCopy>
            )}
            {/* button */}
            {!fromPlccICLogin && (
              <BodyCopy component="div" textAlign="center">
                <Button
                  fill="BLUE"
                  type="submit"
                  buttonVariation="fixed-width"
                  dataLocator="login-logincta"
                  className="elem-mb-MED elem-mt-MED rounded-corner "
                  fullWidth
                  spc
                  onClick={() => setLoginClicked(true)}
                  loading={isLoading && loginClicked}
                  disabled={isLoginBtnDisbaled()}
                >
                  {isV2Flow && !isSMSOpted && lblLoginAndCheckout}
                  {!isV2Flow &&
                    !isSMSOpted &&
                    getLabelFromCopyOrFromTranslation(
                      `${GLOBAL_ACTIONS_LABELS}.${lblLogin}`,
                      GlobalActionsLabels
                    )}
                </Button>
              </BodyCopy>
            )}
            {/* phone number */}
            {!isV2Flow && orRenderer(isV2Flow, fromPlccICLogin)}
            <LineSeperator />
            {!isCanada && showSMSOption && (
              <LoginOptionView
                type="sms"
                maskedPhoneNumber={maskedPhoneNumber}
                submitForm={isBriteVerifyForLoginEnabled ? handleSubmitForm : submitForm2}
                fromPlccICLogin={fromPlccICLogin}
              />
            )}
            {isLoginWithEmailOTPEnabled && (
              <LoginOptionView
                type="email"
                emailAddress={isRememberedUser ? rememberedEmail : emailAddress}
                submitForm={isBriteVerifyForLoginEnabled ? handleSubmitOtp : sendCodeViaEmail}
                fromPlccICLogin={fromPlccICLogin}
              />
            )}
            {isV2Flow && !isRememberedUser && orRenderer(isV2Flow)}
            {getContinueAsGuestBtn(
              isV2Flow,
              variation,
              handleContinueAsGuest,
              isRememberedUser,
              lblLoginCheckoutAsGuest,
              userSavedEmail,
              setShowBriteErrorMessage,
              setBriteErrorMessageData,
              isBriteVerifyForLoginEnabled
            )}
            {fromPlccICLogin && (
              <div className="plcc-footer-cta-section">
                <BodyCopy className="plcc-login-cta-container" component="div" textAlign="left">
                  <Button
                    fill="BLUE"
                    type="submit"
                    buttonVariation="fixed-width"
                    dataLocator="login-logincta"
                    className="elem-mb-LRG elem-mt-LRG plcc-border-style"
                    fullWidth
                    spc
                    onClick={() => setLoginClicked(true)}
                    loading={(isLoading && loginClicked) || isPlccLoginLoading}
                    disabled={isLoginBtnDisbaled()}
                  >
                    {getDynamicLabelValues('dynamic.cart.lbl_plcc_ic_login_modal_cta_text')}
                  </Button>
                </BodyCopy>
              </div>
            )}
          </React.Fragment>
        </form>
      </div>
    </>
  );
};
LoginSelectionFormV2.propTypes = {
  labels: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
  loginErrorMessage: PropTypes.string,
  showRecaptcha: PropTypes.bool,
  change: PropTypes.func,
  pristine: PropTypes.bool,
  handleContinueAsGuest: PropTypes.func.isRequired,
  userplccCardNumber: PropTypes.string.isRequired,
  userplccCardId: PropTypes.string.isRequired,
  showForgotPasswordForm: PropTypes.bool.isRequired,
  resetForm: PropTypes.bool.isRequired,
  resetLoginState: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  tooltipContent: PropTypes.string.isRequired,
  isRememberedUser: PropTypes.bool.isRequired,
  closeModal: PropTypes.func,
  closeOverlay: PropTypes.func,
  fullPage: PropTypes.bool,
  maskedPhoneNumber: PropTypes.string,
  isV2Flow: PropTypes.bool,
  setRememberUser: PropTypes.func,
};
LoginSelectionFormV2.defaultProps = {
  className: '',
  loginErrorMessage: '',
  showRecaptcha: false,
  change: () => {},
  pristine: false,
  closeModal: () => {},
  closeOverlay: () => {},
  fullPage: false,
  maskedPhoneNumber: '',
  resetLoginState: () => {},
  isV2Flow: '',
  setRememberUser: () => {},
};

const validateMethod = createValidateMethod(
  getStandardConfig([
    { emailAddress: 'emailAddressNoAsync' },
    { password: 'legacyPassword' },
    'recaptchaToken',
  ])
);
export default reduxForm({
  form: 'selectionform', // a unique identifier for this form
  enableReinitialize: true,
  ...validateMethod,
})(withStyles(LoginSelectionFormV2, styles));

export { LoginSelectionFormV2 as LoginSelectionFormVanilla };
